export default {
  '400': 'Il y avait une erreur de validation.',
  '401': 'Votre session a expiré.',
  '412': `L'opération n'a pas pu être effectuée.`,
  '403': `Vous n'avez pas les permis nécessaires.`,
  '404': `La ressource demandée n'existe pas.`,
  '407': `Vous devez configurer votre proxy pour utiliser le système.`,
  '408': `Le serveur ne répond pas, essayez plus tard.`,
  '409': `Les données ne sont pas valides`,
  '410': `La ressource demandée n'est plus disponible et ne sera plus disponible.`,
  '500': 'Une erreur est survenue sur le serveur, essayez plus tard.',
  '502': `Le système n'est pas disponible pour le moment, essayez-le plus tard.`,
  '503': `Le système est en maintenance en ce moment, réessayez plus tard s'il vous plaît.`,
  // '504': 'Gateway timeout - Tiempo de espera agotado.', // Esto debe ser implementado en el frontend para reintentar las peticiones
  'connection': `Impossible de se connecter au serveur.`,
  'cancelRequest': `Pétition annulée`,
  'validation': 'Erreur de validation',
  'unknown': `Une erreur inconnue s'est produite, essayez plus tard.`,
  'sessionExpired': `Votre session a expiré, reconnectez-vous.`,
  'oidcSessionExpired': `Votre session avec Ciudadanía Digital a expiré. Nous vous redirigeons pour vous reconnecter.`
};



// WEBPACK FOOTER //
// ./src/lang/fr/errors.js